// extracted by mini-css-extract-plugin
export default {"container":"container__cbpsHeqb","skeleton":"skeleton__HgPgMzLz","title":"title__XoHICjFN","count":"count__tCb2Y5MO","icon":"icon__ketdqf2X","arrowIcon":"arrowIcon__hXrcA1H4"};